import React, {useState} from "react";
import {Box, IconButton, InputAdornment, TextField} from "@mui/material";
import {Visibility, VisibilityOff} from "@mui/icons-material";

export const ValidatedPasswordConfirmedInput = React.forwardRef<any, any>((props, ref) => {
  const [passwordVisible, setPasswordVisible] = useState(false);

  const toggleVisibility = () => setPasswordVisible((isVisible) => !isVisible);

  return (
    <Box sx={props.sx}>
      <TextField
        {...props}
        fullWidth
        ref={ref}
        type={passwordVisible ? "input" : "password"}
        label="Passwort wiederholen"
        inputProps={{
          "aria-label": "Passwort wiederholen",
          autoComplete: "new-password",
        }}
        variant="outlined"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={toggleVisibility}
                size="large">
                {passwordVisible ? <Visibility/> : <VisibilityOff/>}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
});
